interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <nav aria-label="分页" className="flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={currentPage === 1}
        onClick={() => onChange(currentPage - 1)}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`flex h-9 w-9 items-center justify-center rounded-md border text-sm transition-colors cursor-pointer ${
            page === currentPage
              ? "border-primary-600 bg-primary-600 text-background-50"
              : "border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
          }`}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        disabled={currentPage === totalPages}
        onClick={() => onChange(currentPage + 1)}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 whitespace-nowrap"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}